// The rules behind two quiet notes on the start page, with no DOM: "Install Re:Vault" (app/install.js)
// and "What's new" after an update (app/whats-new.js). Shared by the app bundle (the gates, and the
// What's new chip) and the lazy chunk that draws the install note (app/notes.js);
// test/growth.test.mjs checks them.

export const INSTALL_KEY = "revault:install";
export const NEWS_KEY = "revault:release-seen";
export const WEEK = 7 * 864e5;
export const NEED_DAYS = 3;
export const NEWS_DAYS = 14;
// Asked this many times without an install: stop asking (Settings can still turn it back on).
export const MAX_ASKS = 3;

export const dayKey = (d) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");

// The install record with today added: the last few distinct days (dates only), newest first.
export function noteDay(rec, today) {
	const r = rec && typeof rec === "object" ? rec : {};
	const days = (Array.isArray(r.days) ? r.days : []).filter((d) => typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d) && d !== today);
	return { days: [today, ...days].slice(0, 5), shown: Number(r.shown) || 0, asks: Number(r.asks) || 0 };
}

// May the install note show now? Back on 3 different days, not shown in the last week, asked fewer
// than 3 times, the setting on, not installed already, the browser able to install, and nothing
// (Study Hall, a focus timer, a dialog) in front.
export function mayOffer(rec, { now, setting, standalone, busy, canPrompt }) {
	if (setting === false || standalone || busy || !canPrompt) return false;
	if (!rec || !Array.isArray(rec.days) || rec.days.length < NEED_DAYS) return false;
	if ((Number(rec.asks) || 0) >= MAX_ASKS) return false;
	return !(rec.shown && now - rec.shown < WEEK);
}

// What's new on this load: "show", "remember" (a first visit: just note the release) or "".
// before: this browser used Re:Vault on an earlier day (it was here before the note existed).
export function decideNews(rel, seen, now, before) {
	if (!rel) return "";
	if (!seen || typeof seen !== "object") return before ? "show" : "remember";
	if (seen.v !== rel.v) return "show";
	return seen.done || (seen.at && now - seen.at > NEWS_DAYS * 864e5) ? "" : "show";
}
export const anchorOf = (v) => "v" + String(v).replace(/\./g, "-");
export const newsLabel = (rel) => "What's new in v" + rel.v.replace(/\.0$/, "") + (rel.name ? ": " + rel.name : "");
// The chip's few words, next to its New tag; the full label is its accessible name and tooltip.
export const newsShort = (rel) => rel.name || "v" + rel.v.replace(/\.0$/, "");
